import React, { useEffect } from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
import ActionCenterMessageDetail from './ActionCenterMessageDetail';

interface Props {
	isOpen: true;
	onClose: () => void;
	conversationId: string;
}

const ActionCenterMessageDetailModal: React.FC<Props> = ({
	isOpen,
	onClose,
	conversationId,
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} size={Size.FULLSCREEN}>
			<Modal.Content>
				<div style={{ margin: '-34px -24px' }}>
					<ActionCenterMessageDetail
						conversationId={conversationId}
						onBack={onClose}
					/>
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default ActionCenterMessageDetailModal;
